import { z } from 'zod';
import { floatNumSchema } from '../../validation';

export const orderDistanceInfoSchema = z.object({
  value: floatNumSchema,
  text: z.string().trim(),
});
export type OrderDistanceInfo = z.infer<typeof orderDistanceInfoSchema>;

export const orderDistanceSchema = z.object({
  /** the time such as 10 hours */
  duration: orderDistanceInfoSchema,
  /** the distance such as 10Km */
  distance: orderDistanceInfoSchema,
});
export type OrderDistance = z.infer<typeof orderDistanceSchema>;
